var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"tabs-row"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.id},[_c('button',{class:['tabs-row__button', _vm.activeValue === tab.value && 'tabs-row__button--active'],on:{"click":function($event){return _vm.setTab(tab.value)}}},[_vm._v("\n      "+_vm._s(tab.title)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }